/* =====================================================================
   hl-filter-rules.js — per-collection filter groups (app-free)
   ---------------------------------------------------------------------
   Source of truth: the "Filter Recommendations" sheet (one entry per
   collection handle). Read by snippets/hl-native-filter.liquid: when the
   current collection has an entry here, its sidebar shows exactly these
   groups (in this order), then Availability (In Stock / Out of Stock),
   then Price. Collections without an entry keep the old behaviour.

   Group spec:
     name      Sidebar heading.
     src       Where the rules look:
                 'title' product title
                 'text'  title + product type + tags + all variant options (default)
                 'body'  'text' + description
                 'opt'   each variant value of the options whose NAME matches
                         "opt" (falls back to the title when there are none)
     opt       RegExp on the option name, for src 'opt'.
     rules     [matcher, 'Value'] pairs, in the order values should list.
               matcher = RegExp (no g flag) or function(haystack, product).
               inch(lo, hi) / vol(lo, hi) build size / volume matchers.
     one       true -> first matching rule only (default: every match).
     skip      RegExp on the title -> product gets no value in this group.
     fallback  Value when nothing matched.
     member    { 'collection-handle': 'Value' } -> value from membership.
     order     ['Value', ...] -> display order, when it differs from rule priority.
     hide      ['Value', ...] -> matched but not shown (values outside the
               approved sheet); the product simply gets no value for them.

   To add or change a collection, edit its block below — nothing else
   needs to change. ES5 only.
   ===================================================================== */
(function(root){
  var R = {};

  function strip(h){
    return String(h || '').replace(/<[^>]+>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ').replace(/\s+/g, ' ');
  }
  function optName(o){ return typeof o === 'string' ? o : (o && o.name); }
  function optVals(p, re){
    var out = [];
    (p.options || []).forEach(function(o, ix){
      var nm = optName(o);
      if (!nm || nm === 'Title' || (re && !re.test(nm))) return;
      (p.variants || []).forEach(function(v){
        var x = v['option' + (ix + 1)];
        if (x && x !== 'Default Title' && out.indexOf(x) === -1) out.push(x);
      });
    });
    return out;
  }
  function hay(p, g){
    var title = p.title || '';
    if (g.src === 'title') return [title];
    if (g.src === 'opt') { var ov = optVals(p, g.opt); return ov.length ? ov : [title]; }
    var t = [title, p.product_type || '', (p.tags || []).join(' '), optVals(p).join(' | ')].join(' | ');
    if (g.src === 'body') t += ' | ' + strip(p.body_html);
    return [t];
  }
  function test(m, h, p){ return typeof m === 'function' ? !!m(h, p) : m.test(h); }

  /* APPROVED VALUES (assets/hl-filter-map.js, built from the review sheet).
     HLF.map[collection] = { g: [groupNames], v: [[values per group]],
                             p: { productHandle: [[value indexes per group]] } }
     A product listed there gets exactly those values; the rules below
     only cover products the sheet doesn't list yet (e.g. new products). */
  var M = {};
  /* 32-bit FNV-1a of the product handle, base 36: the map stores this short
     key instead of the full handle (h: 1) to keep the file small. */
  function hkey(s){
    var h = 0x811c9dc5, i;
    for (i = 0; i < s.length; i++){ h ^= s.charCodeAt(i); h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0; }
    return h.toString(36);
  }
  function fromMap(p, collection){
    var c = M[collection], row = c && c.p && c.p[c.h ? hkey(p.handle || '') : p.handle];
    if (!row) return null;
    var opts = {};
    c.g.forEach(function(name, gi){
      var vals = (row[gi] || []).map(function(ix){ return c.v[gi][ix]; }).filter(Boolean);
      if (vals.length) opts[name] = vals;
    });
    return opts;
  }

  /* member: { collectionHandle: [productHandles] } for cfg's member groups */
  function classify(p, cfg, member, collection){
    var opts = fromMap(p, collection);
    if (opts) {
      opts['Availability'] = [(p.variants || []).some(function(v){ return v.available; }) ? 'In Stock' : 'Out of Stock'];
      return opts;
    }
    opts = {};
    (cfg.groups || []).forEach(function(g){
      if (g.skip && g.skip.test(p.title || '')) return;
      var hs = hay(p, g), vals = [], i, j;
      for (i = 0; i < (g.rules || []).length; i++){
        var r = g.rules[i];
        if (vals.indexOf(r[1]) !== -1) continue;
        for (j = 0; j < hs.length; j++) if (test(r[0], hs[j], p)) { vals.push(r[1]); break; }
        if (g.one && vals.length) break;
      }
      if (g.member && member && !(g.one && vals.length)){
        for (var h in g.member) if ((member[h] || []).indexOf(p.handle) !== -1 && vals.indexOf(g.member[h]) === -1) vals.push(g.member[h]);
      }
      if (!vals.length && g.fallback) vals.push(g.fallback);
      if (g.hide) vals = vals.filter(function(v){ return g.hide.indexOf(v) === -1; });
      if (vals.length) opts[g.name] = vals;
    });
    var avail = (p.variants || []).some(function(v){ return v.available; });
    opts['Availability'] = [avail ? 'In Stock' : 'Out of Stock'];
    return opts;
  }

  /* display order of a group's values = rule order */
  function order(cfg, name){
    if (name === 'Availability') return ['In Stock', 'Out of Stock'];
    var out = [];
    (cfg.groups || []).forEach(function(g){
      if (g.name !== name) return;
      (g.order || []).forEach(function(v){ out.indexOf(v) === -1 && out.push(v); });
      (g.rules || []).forEach(function(r){ out.indexOf(r[1]) === -1 && out.push(r[1]); });
      if (g.member) for (var h in g.member) out.indexOf(g.member[h]) === -1 && out.push(g.member[h]);
      if (g.fallback && out.indexOf(g.fallback) === -1) out.push(g.fallback);
      if (g.hide) out = out.filter(function(v){ return g.hide.indexOf(v) === -1; });
    });
    return out;
  }
  function memberHandles(cfg){
    var out = [];
    (cfg.groups || []).forEach(function(g){ if (g.member) for (var h in g.member) out.indexOf(h) === -1 && out.push(h); });
    return out;
  }

  /* ---- measurement helpers -------------------------------------------
     inches(s): the LARGEST dimension of every measurement found in s, in
       inches ("5.5 x 3 Inches" -> 5.5, '8"' -> 8, "20 cm" -> 7.87).
     ml(s): every volume found in s, in ml ("2 fl. oz" -> 59).          */
  /* ".32" and "1/4" count as numbers too */
  var NUM = '(\\d+/\\d+|\\d*\\.\\d+|\\d+)';
  var DIM = NUM + '(?:\\s*[x\\u00d7X]\\s*' + NUM + ')?(?:\\s*[x\\u00d7X]\\s*' + NUM + ')?\\s*';
  function num(s){ var f = String(s || '').split('/'); return f.length === 2 ? +f[0] / +f[1] : +(s || 0); }
  function biggest(m){ return Math.max(num(m[1]), num(m[2]), num(m[3])); }
  function inches(s){
    var out = [], m, re;
    s = String(s || '');
    re = new RegExp(DIM + '(?:"|\\u2033|\\u201d|\'\'|inch(?:es)?\\b)', 'gi');
    while ((m = re.exec(s))) out.push(biggest(m));
    re = new RegExp(DIM + 'cm\\b', 'gi');
    while ((m = re.exec(s))) out.push(Math.round(biggest(m) / 2.54 * 100) / 100);
    return out;
  }
  function ml(s){
    var out = [], m, re;
    s = String(s || '');
    re = /(\d*\.\d+|\d+)\s*ml\b/gi;
    while ((m = re.exec(s))) out.push(+m[1]);
    if (!out.length){
      re = /(\d+\/\d+|\d*\.\d+|\d+)\s*(?:fl\.?\s*)?oz\b/gi;
      while ((m = re.exec(s))) out.push(Math.round(num(m[1]) * 29.57));
    }
    return out;
  }
  /* matcher factories: true when ANY measurement falls in [lo, hi) */
  function inch(lo, hi){ return function(h){ return inches(h).some(function(x){ return x >= lo && x < hi; }); }; }
  function vol(lo, hi){ return function(h){ return ml(h).some(function(x){ return x >= lo && x < hi; }); }; }

  /* the map file may load before or after this one */
  if (root.HLF && root.HLF.map) M = root.HLF.map;
  var HLF = { rules: R, map: M, hkey: hkey, classify: classify, order: order, memberHandles: memberHandles,
              inches: inches, ml: ml, inch: inch, vol: vol };
  root.HLF = HLF;
  if (typeof module !== 'undefined' && module.exports) module.exports = HLF;

/* =========================== RULES (one block per collection) =========================== */

/* Anointing Oils — 61 products. Scents live in titles + Scent/Material Type options. */
R['anointing-oils'] = { groups: [
  { name: 'Scent', skip: /\bset\b|samples|keepsake/i, rules: [
    [/frankincense\s*(&|and)\s*myrrh|myrrh,\s*frankincense/i, 'Frankincense & Myrrh'],
    [/frankincense/i, 'Frankincense'],
    [/myrrh|mirra/i, 'Myrrh'],
    [/spikenard|\bnard\b/i, 'Spikenard/Nard'],
    [/rose of sharon/i, 'Rose of Sharon'],
    [/lily of the valley/i, 'Lily of the Valleys'],
    [/jasmin/i, 'Jasmine'],
    [/\bmusk\b/i, 'Musk'],
    [/cinnamon/i, 'Cinnamon'],
    [/pomegranate/i, 'Pomegranate'],
    [/hyssop/i, 'Hyssop'],
    [/cedar/i, 'Cedar of Lebanon'],
    [/henna/i, 'Henna'],
    [/song(s)? of songs/i, 'Songs of Songs']
  ]},
  { name: 'Size / Volume', skip: /\bset\b|samples|keepsake/i, rules: [
    [vol(0, 20), 'Small (7.5-15 ml)'],
    [vol(20, 200), 'Medium (60-125 ml)'],
    [vol(200, 9999), 'Large (200-300 ml)']
  ]},
  { name: 'Oil Line', one: true, rules: [
    [/\bset\b|samples|keepsake/i, 'Gift Set'],
    [/ein gedi/i, 'Ein Gedi'],
    [/sepulch/i, 'Blessed Holy Sepulchre']
  ], fallback: 'From the Holy Land' },
  { name: 'Bottle Type', skip: /\bset\b|samples|keepsake/i, one: true, rules: [
    [/roll-?on/i, 'Roll-On'],
    [/cobalt/i, 'Cobalt Blue Glass'],
    [/ampoule/i, 'Gift Ampoule']
  ], fallback: 'Standard Bottle' }
]};

/* Ein Gedi Anointing Oils — 49 products (data/ao-ein-gedi.json). Scents in titles + Material Type options (tags are noisy, so not read); a few short-titled items name the scent only in the description. */
R['ao-ein-gedi'] = { groups: [
  { name: 'Scent', src: 'opt', opt: /material|scent/i, skip: /\bset\b|samples|keepsake/i, rules: [
    [/frankincense/i, 'Frankincense'],
    [/myrrh|mirra/i, 'Myrrh'],
    [/^scented anointing oil from the holy land$/i, 'Myrrh'],
    [/frankincense\s*(&|and)\s*myrrh|myrrh,\s*frankincense/i, 'Frankincense & Myrrh'],
    [/^holy land market blessing from jerusalem anointing oil - 10ml/i, 'Frankincense & Myrrh'],
    [/spikenard|\bnard\b/i, 'Spikenard'],
    [/rose of sharon/i, 'Rose of Sharon'],
    [/lily of the valley/i, 'Lily of the Valleys'],
    [/^anointing oil from jerusalem$/i, 'Lily of the Valleys'],
    [/cinnamon/i, 'Cinnamon'],
    [/pomegranate/i, 'Pomegranate'],
    [/hyssop/i, 'Hyssop'],
    [/cedar/i, 'Cedar of Lebanon'],
    [/^biblical gift - anointing oil flask$/i, 'Cedar of Lebanon'],
    [/henna/i, 'Henna'],
    [/song(s)? of songs/i, 'Songs of Songs']
  ]},
  { name: 'Bottle Type', hide: ['Standard Bottle'], src: 'title', skip: /\bset\b|samples|keepsake/i, one: true, rules: [
    [/roll-?on/i, 'Roll-On (10 ml)'],
    [/cobalt/i, 'Cobalt Blue (15 ml)'],
    [function(h, p){ return /\b8 ?ml/i.test(p.title) && /ampoule/i.test(p.body_html || ''); }, 'Gift Ampoule (8 ml)'],
    [vol(200, 9999), 'Large/Church (250 ml)']
  ], fallback: 'Standard Bottle' },
  { name: 'Named Series', src: 'title', skip: /\bset\b|samples|keepsake/i, one: true, rules: [
    [/gold collection/i, 'Gold Collection'],
    [/biblical spices/i, 'Biblical Spices'],
    [/messiah|masheiach/i, 'Messiah/Masheiach']
  ], fallback: 'Classic (Unthemed)' }
]};

/* Ceramic & Glass — 172 products (data/ceramic-glass.json). Material/type live in titles; tags ("olive,wood") are noise; designs also in Size/Color options. */
R['ceramic-glass'] = { groups: [
  { name: 'Material', src: 'title', rules: [
    [/ceramic|pottery|armenian|painted tile|tile from jerusalem|wall clock|^loaves and fish plate/i, 'Armenian Ceramic'],
    [/olive\s*wood|olivewood/i, 'Olive Wood'],
    [/phoenician/i, 'Phoenician Glass'],
    [/resin/i, 'Resin']
  ]},
  { name: 'Design / Pattern', hide: ['Jerusalem City View'], rules: [
    [/tabgha|\bfish|loaves/i, 'Tabgha (Fish & Bread)'],
    [/shalom|peace|pigeon/i, 'Shalom (Peace Dove)'],
    [/jerusalem flowers|holy land flowers/i, 'Jerusalem Flowers'],
    [/jerusalem city|jerusalem ceramic wall clock/i, 'Jerusalem City View'],
    [/blue flower/i, 'Blue Flowers'],
    [/seven species/i, 'Seven Species'],
    [/peacock/i, 'Peacock'],
    [/^(?!.*(last supper|fish|loaves|ceramic|resin)).*olive\s*wood/i, 'Natural Grain']
  ]},
  { name: 'Item Type', hide: ['Vase','Cross/Crucifix'], src: 'title', one: true, rules: [
    [/^(?!.*(ashtray|clock|trivet|hot plate)).*(bowl|dish)/i, 'Bowl'],
    [/^(?!.*(cups?\b|goblet|chalice|trivet|hot plate|ashtray|clock)).*plate/i, 'Plate'],
    [/^(?!.*(trivet|hot plate|spoon rest)).*(\bcups?\b|\bmugs?\b|goblet|chalice|coffee set)/i, 'Mug/Cup'],
    [/^(?!.*(spoon rest|cellar)).*(spoon|spatula|scoop)/i, 'Spoon'],
    [/^(?!.*(spoon rest|ladle holder)).*ladle/i, 'Ladle'],
    [/coaster/i, 'Coaster'],
    [/trivet|hot plate/i, 'Trivet'],
    [/clock/i, 'Clock'],
    [/\btile\b/i, 'Tile'],
    [/ashtray/i, 'Ashtray'],
    [/cellar|keeper|container/i, 'Container'],
    [/vase/i, 'Vase'],
    [/\bcross\b|crucifix/i, 'Cross/Crucifix']
  ]}
]};

/* Glass & Resin Crosses — 24 products (HLF/data/gc-glass-resin-crosses.json). Type/subject/display in titles (+ "ready to hang" in descriptions); color from Color option or title. */
R['gc-glass-resin-crosses'] = { groups: [
  /* the 2 miniature hand-blown glass crosses (boxed keepsakes) fit no type -> no value */
  { name: 'Product Type', src: 'title', one: true, rules: [
    [/hand held|holding|comfort|healing cross|hand fit|pocket/i, 'Pocket/Hand Cross'],
    [/^(?!.*(\btable\b|standing|candle vigil|glass)).*(cross|crucifix|corpus)/i, 'Wall Cross'],
    [/^(?!.*glass).*(\btable\b|standing|candle vigil)/i, 'Table Crucifix'],
    [/angel/i, 'Angel Figurine'],
    [/nativity/i, 'Nativity'],
    [/commandments|decalogue|charbel/i, 'Religious Figure'],
    [/chalice|communion cup/i, 'Communion Chalice']
  ]},
  { name: 'Display Type', src: 'title', rules: [
    [/hand held|holding|comfort|healing cross|hand fit|pocket/i, 'Hand-held'],
    [function(h, p){ return /wall|ready to hang/i.test(h) || /ready to hang|ready for hanging|metal hanger|hangs on the wall/i.test(p.body_html || ''); }, 'Wall-Hanging'],
    [/\btable\b|standing|candle vigil|chalice|communion cup|nativity|angel|wooden base/i, 'Table-Standing']
  ]},
  { name: 'Subject', src: 'title', rules: [
    [/crucifix|corpus|sacred heart|scared heart|risen|heart of our lord/i, 'Jesus/Crucifix'],
    [/benedict/i, 'St. Benedict'],
    [/charbel/i, 'Mar Charbel'],
    [/angel/i, 'Angel'],
    [/nativity/i, 'Nativity'],
    [/commandments|decalogue/i, 'Ten Commandments']
  ]},
  /* resin hand crosses are wood-toned ("not wooden but with wooden tone") -> Natural */
  { name: 'Color', src: 'opt', opt: /colou?r/i, rules: [
    [function(h, p){ return /natural|wood(en)? tone/i.test(h) || (h === p.title && /not wooden but with wooden tone/i.test(p.body_html || '')); }, 'Natural'],
    [/blue/i, 'Blue'],
    [/brown|dark/i, 'Brown/Dark'],
    [/pink|rose/i, 'Pink'],
    [/\bred\b/i, 'Red']
  ]}
]};

/* Gift Shop Incense Burners — 7 products (data/gc-incense-burners.json). Size in titles (kit burner's only in description); style/kit contents from titles + descriptions. */
R['gc-incense-burners'] = { groups: [
  { name: 'Type', src: 'title', one: true, rules: [
    [/^(?!.*lamp).*burner/i, 'Burner'],
    [/charcoal/i, 'Charcoal/Accessory'],
    [/lamp/i, 'Lamp']
  ]},
  { name: 'Burner Size', src: 'body', skip: /lamp|^instant/i, rules: [
    [function(h, p){ return inch(2.5, 4)(p.title); }, '3"'],
    [function(h, p){ return inch(4, 5.5)(p.title); }, '4.8"'],
    [function(h, p){ return inch(5.5, 6.25)(p.title) || /15 cm or 6 inches tall/i.test(h); }, '6"'],
    [function(h, p){ return inch(6.25, 7)(p.title); }, '6.5"']
  ]},
  { name: 'Style', src: 'body', skip: /^instant/i, rules: [
    [/flat-?top/i, 'Basic / Flat-Top'],
    [/pedestal/i, 'Pedestal'],
    [/mesh screen/i, 'Adjustable Mesh'],
    [/hanging|hangs from a chain/i, 'Hanging']
  ]},
  { name: 'Includes Kit', src: 'title', skip: /charcoal from|^instant/i, rules: [
    [/\bkit\b/i, 'With Kit (incense + charcoal)']
  ], fallback: 'Burner Only' }
]};

/* Gift Shop Incense — 6 products (data/gc-incense.json). Fragrances in Color/Material options (title when none); weight in titles. */
R['gc-incense'] = { groups: [
  { name: 'Form', src: 'title', rules: [
    [/^(?!.*stick).*incense/i, 'Loose Granules'],
    [/stick/i, 'Incense Sticks']
  ]},
  { name: 'Fragrance', src: 'opt', opt: /colou?r|material/i, skip: /stick/i, rules: [
    [/\brose\b/i, 'Rose'],
    [/frankincense/i, 'Frankincense'],
    [/myrrh|myrra|\bmyra\b/i, 'Myrrh'],
    [/\bnard\b/i, 'Nard'],
    [/jasmin/i, 'Jasmine'],
    [/amber/i, 'Amber'],
    [/\bmusk\b|\bmisk\b/i, 'Musk'],
    [/violet/i, 'Violet'],
    [/gardenia/i, 'Gardenia'],
    [/night flower/i, 'Night Flower'],
    [/paschalia/i, 'Paschalia'],
    [/\bmix\b/i, 'Mix']
  ]},
  { name: 'Weight', src: 'title', rules: [
    [/\b30 ?(g|grams)\b/i, '30g'],
    [/90-110 ?(g|grams)/i, '90-110g'],
    [/\b100 ?(g|grams)\b/i, '100g'],
    [/one pound|\b1 ?lb\b/i, '1 lb']
  ]}
]};

/* Gift Shop Tiles — 17 products (data/gc-tiles.json). All Jerusalem painted tiles; type/size in titles (Modular Model, 6x3 blessing, 3x1.5 numeral). */
R['gc-tiles'] = { groups: [
  { name: 'Tile Type', src: 'title', one: true, rules: [
    [/^(?!.*(6x3|numeral|3x1\.5)).*(modular|6 inch)/i, 'Decorative (6")'],
    [/6x3|bless|welcome/i, 'Text/Blessing (6x3")'],
    [/numeral|3x1\.5/i, 'Numeral (3x1.5")']
  ]},
  { name: 'Use', src: 'title', rules: [
    [/^(?!.*(numeral|3x1\.5)).*(modular|6x3|bless|welcome|6 inch)/i, 'Wall Decor'],
    [/numeral|3x1\.5/i, 'House Number'],
    [/modular/i, 'Kitchen Decor'],
    [/modular/i, 'Modular Display']
  ]}
]};

/* Incense & Burners — 13 products (data/incense-burners.json). Type/form/weight in titles; origin in titles + descriptions (Mount Athos). */
R['incense-burners'] = { groups: [
  { name: 'Type', src: 'title', one: true, rules: [
    [/^(?!.*(burner|charcoal)).*incense/i, 'Incense'],
    [/burner/i, 'Incense Burner'],
    [/charcoal/i, 'Charcoal']
  ]},
  { name: 'Form', src: 'title', skip: /burner|charcoal/i, rules: [
    [/^(?!.*stick).*incense/i, 'Loose Granules'],
    [/stick/i, 'Incense Sticks']
  ]},
  { name: 'Origin', src: 'body', skip: /burner/i, rules: [
    [function(h, p){ return /jerusalem|holy land(?! market)/i.test(p.title); }, 'Jerusalem/Holy Land'],
    [/mount athos|greece/i, 'Mount Athos/Greece'],
    [function(h, p){ return /india/i.test(p.title); }, 'India (sticks)']
  ]}
]};

/* Jesus Biblical Sandals — 63 live products (data/jesus-biblical-sandals.json). Material/style from the 4 sub-collections
   (data/jesus-biblical-{leather,suede}-{sandals,flip-flops}.json); sizes are US labels in the Size option, mapped to EU
   by the store's own ladder (3.5-4 Big Kid = EU 35 ... 19-19.5 Women = EU 50, confirmed by "EU 35-50" listings). */
R['jesus-biblical-sandals'] = { groups: [
  /* titles agree with membership on all 63: only suede pairs say "Suede" */
  { name: 'Material', src: 'title', one: true, rules: [
    [/^(?!.*suede)/i, 'Genuine Leather'],
    [/suede/i, 'Suede']
  ], member: {
    'jesus-biblical-leather-sandals': 'Genuine Leather',
    'jesus-biblical-leather-flip-flops': 'Genuine Leather',
    'jesus-biblical-suede-sandals': 'Suede',
    'jesus-biblical-suede-flip-flops': 'Suede'
  }},
  /* titles all say "Sandals/Slides", so style comes from membership only */
  { name: 'Style', member: {
    'jesus-biblical-leather-sandals': 'Sandal',
    'jesus-biblical-suede-sandals': 'Sandal',
    'jesus-biblical-leather-flip-flops': 'Flip Flop / Slide',
    'jesus-biblical-suede-flip-flops': 'Flip Flop / Slide'
  }},
  { name: 'Size', src: 'opt', opt: /size/i, rules: [
    [/^3\.5-4 big kid|^(eu\s*)?35$/i, 'EU 35'],
    [/^4-4\.5 big kid|^(eu\s*)?36$/i, 'EU 36'],
    [/^6-6\.5 women|^(eu\s*)?37$/i, 'EU 37'],
    [/^7-7\.5 women|^(eu\s*)?38$/i, 'EU 38'],
    [/^8-8\.5 women|^(eu\s*)?39$/i, 'EU 39'],
    [/^9-9\.5 women|^(eu\s*)?40$/i, 'EU 40'],
    [/^10-10\.5 women|^(eu\s*)?41$/i, 'EU 41'],
    [/^11-11\.5 women|^(eu\s*)?42$/i, 'EU 42'],
    [/^12-12\.5 women|^(eu\s*)?43$/i, 'EU 43'],
    [/^13-13\.5 women|^(eu\s*)?44$/i, 'EU 44'],
    [/^14-14\.5 women|^(eu\s*)?45$/i, 'EU 45'],
    [/^(1[5-9]|2\d)-\d+\.5 women|^(eu\s*)?(4[6-9]|50)$/i, 'EU 46+']
  ]},
  /* every style is unisex and comes in adult sizes; Kids = also offered in children's sizes (EU 27-34) or titled for children */
  { name: 'Gender', rules: [
    [/men|unisex|adult/i, 'Unisex/Adult'],
    [/little kid|\b(1\.5-2|2\.5-3) big kid|children/i, 'Kids']
  ]}
]};

/* Jewelry — 78 products (HLF/data/jewelry-1.json). Type/material/theme in titles (+ own description for the tungsten base of gold-IP bands). */
R['jewelry-1'] = { groups: [
  /* title + description only (the shared SEO tags would add Christmas etc. everywhere) */
  { name: 'Occasion', rules: [
    [function(h, p){ return /baptisms?\b(?! of (jesus|christ|our lord))/i.test(p.title + ' ' + (p.body_html || '')); }, 'Baptism'],
    [function(h, p){ return /first communion/i.test(p.title + ' ' + (p.body_html || '')); }, 'First Communion'],
    [function(h, p){ return /confirmation/i.test(p.title + ' ' + (p.body_html || '')); }, 'Confirmation'],
    [function(h, p){ return /\beaster\b/i.test(p.title + ' ' + (p.body_html || '')); }, 'Easter'],
    [function(h, p){ return /christmas/i.test(p.title + ' ' + (p.body_html || '')); }, 'Christmas'],
    [function(h, p){ return /bereave|sympathy|funeral|memorial|\bgrief|in memory/i.test(p.title + ' ' + (p.body_html || '')); }, 'Memorial / Sympathy'],
    [function(h, p){ return /wedding|bridal/i.test(p.title + ' ' + (p.body_html || '')); }, 'Wedding']
  ]},
  /* chaplets / rosary sets with no bracelet/necklace wording get no type */
  { name: 'Jewelry Type', src: 'title', one: true, rules: [
    [/\bbrac|wristband|cuff/i, 'Bracelet'],
    [/^(?!.*(\bring\b|\bband\b)).*(pendant|necklace|chain|medal)/i, 'Pendant/Necklace'],
    [/\bring\b|\bband\b/i, 'Ring']
  ]},
  { name: 'Material', src: 'title', rules: [
    [/olive ?wood/i, 'Olive Wood'],
    [/stainless/i, 'Stainless Steel'],
    [function(h, p){ return /tungsten/i.test(h) || (/\b(ring|band)\b/i.test(h) && /tungsten/i.test(String(p.body_html || '').split(/<a\b[^>]*>[\s\S]*?<\/a>/i).join(' ').split(/<[^>]+>/).join(' ').split(/[.!?]\s/).filter(function(s){ return !/browse/i.test(s); }).join(' '))); }, 'Tungsten Carbide'],
    [/rhodium/i, 'Rhodium-Plated']
  ]},
  { name: 'Religious Theme', src: 'title', rules: [
    [/messianic|star of david (with|and) (a )?cross|messianic seal/i, 'Messianic'],
    [/^(?!.*messianic).*(cross|crucifix|chaplet|rosar|medjugorje|saint|mary|nickolas|kazam|jesus)/i, 'Christian/Cross'],
    [/^(?!.*(messianic|with cross|and cross|with a cross)).*(shema|shma|star of david|ani ledodi|hebrew|12 tribes|hoshen|israel)/i, 'Jewish/Hebrew']
  ]}
]};

/* Jewelry Rings — 37 products (HLF/data/jewelry-rings.json). Material/design/finish in titles (+ own description for the tungsten base); sizes in the Ring Size option. */
R['jewelry-rings'] = { groups: [
  { name: 'Material', src: 'title', rules: [
    /* gold-IP bands are plated tungsten: the description says so (link text / "browse" sentences ignored) */
    [function(h, p){ return /tungsten/i.test(h + ' ' + String(p.body_html || '').split(/<a\b[^>]*>[\s\S]*?<\/a>/i).join(' ').split(/<[^>]+>/).join(' ').split(/[.!?]\s/).filter(function(s){ return !/browse/i.test(s); }).join(' ')); }, 'Tungsten Carbide'],
    [/18k gold|gold ion|gold (and silver )?ion/i, '18K Gold Ion Plated'],
    [/stainless/i, 'Stainless Steel']
  ]},
  { name: 'Ring Size', src: 'opt', opt: /ring size|size/i, rules: [
    [/^\s*6\.5\s*$/, '6.5'],
    [/^\s*7\s*$/, '7'],
    [/^\s*8\s*$/, '8'],
    [/^\s*9\s*$/, '9'],
    [/^\s*10\s*$/, '10'],
    [/^\s*11\s*$/, '11'],
    [/^\s*12\s*$/, '12']
  ]},
  { name: 'Design / Theme', src: 'title', rules: [
    [/cross/i, 'Cross'],
    [/celtic/i, 'Celtic'],
    [/fleur/i, 'Fleur-de-lis'],
    [/hebrew|ani ledodi|shema/i, 'Hebrew Scripture'],
    [/sport|football/i, 'Sports/Football'],
    [/romantic|heart|love/i, 'Heart/Romantic'],
    /* no motif, no inlay / stones / carving */
    [/^(?!.*(cross|celtic|fleur|hebrew|ani ledodi|sport|football|romantic|heart|love|inlay|cz|zirconia|stone|carved|waves|engraved|fishskin|shell)).*(ring|band)/i, 'Plain/Black']
  ]},
  { name: 'Finish', src: 'title', rules: [
    [function(h, p){ return /high(ly)? polish/i.test(h + ' ' + String(p.body_html || '').split(/<a\b[^>]*>[\s\S]*?<\/a>/i).join(' ').split(/<[^>]+>/).join(' ').split(/[.!?]\s/).filter(function(s){ return !/browse/i.test(s); }).join(' ')); }, 'High Polish'],
    [/black (18k )?ip|18k black ip/i, 'Black IP'],
    [/18k gold|gold ion|gold (and silver )?ion|gold ip/i, 'Gold IP']
  ]}
]};

/* Jordan River Holy Water — 7 live products (data/jordan-river-holy-water.json). Volume in titles/Size option (else description); pack counts in Style option. */
R['jordan-river-holy-water'] = { groups: [
  /* volume from title + options; only when those carry none, from the description */
  { name: 'Volume', rules: [
    [function(h, p){ return vol(0, 15)(vol(0, 1e9)(h) ? h : String(p.body_html || '').replace(/<[^>]+>/g, ' ')); }, 'Small Vial (under 15 ml)'],
    [function(h, p){ return vol(15, 175)(vol(0, 1e9)(h) ? h : String(p.body_html || '').replace(/<[^>]+>/g, ' ')); }, 'Medium (100 ml / 3.4 oz)'],
    [function(h, p){ return vol(175, 9999)(vol(0, 1e9)(h) ? h : String(p.body_html || '').replace(/<[^>]+>/g, ' ')); }, 'Large (250 ml / 8.5 oz)']
  ]},
  { name: 'Format', rules: [
    [/bottle only/i, 'Standard Bottle'],
    [/carton|gift box|decorative box/i, 'Gift Box/Carton'],
    [/cross[- ]shaped/i, 'Cross-Shaped Bottle'],
    [/\bvial/i, 'Glass Vial'],
    [/olive wood.*cross cover/i, 'With Olive Wood Cross Cover']
  ], fallback: 'Standard Bottle' },
  { name: 'Quantity', src: 'opt', opt: /style|quantity|pack/i, rules: [
    [/^(1 bottles?|one|bottle only|bottle with carton)\b|\bone small\b/i, 'Single'],
    [/\b2 bottles\b/i, '2-Pack'],
    [/\b5 bottles\b/i, '5-Pack']
  ], fallback: 'Single' }
]};

/* Judaica Mezuzahs & Scrolls — 51 products (data/judaica-mezuzahs-scrolls.json). Material/size in titles; design partly in the first body sentence. */
R['judaica-mezuzahs-scrolls'] = { groups: (function(){
  var KLAF = /(?:fits?|up to)\s+(?:up to\s+)?[\d.\/]+\s*(?:inch(?:es)?|")\s*klaf|\(?cavity[^)]*\)?/i;
  function body(p){ return String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ').replace(/\s+/g, ' '); }
  function lead(p){ return body(p).slice(0, 220); }
  function L(re){ return function(h, p){ return re.test(h + ' | ' + lead(p)); }; }
  function sz(lo, hi){ var f = inch(lo, hi), any = inch(0, 999); return function(h, p){
    h = h.split(KLAF).join(' ');
    if (!any(h)) { var m = body(p).match(/measuring\s+(?:about\s+)?[\d.]+\s*(?:cm|inch(?:es)?)\b/i); h = m ? m[0] : ''; }
    return f(h); }; }
  return [
  { name: 'Material', rules: [
    [/olive\s*wood/i, 'Olive Wood'],
    [function(h, p){ return /gold[\s-]*plated|silver[\s-]*plated|\bmetal\b(?!\s+plate)/i.test(h) || /colou?red metal/i.test(lead(p)) || (/\bcrown mezuzah\b/i.test(p.title) && /gold|silver/i.test(h)); }, 'Metal (Gold/Silver Plated)'],
    [/bronze|brass/i, 'Bronze'],
    [/pewter/i, 'Pewter'],
    [/copper/i, 'Copper'],
    [function(h){ return /wood/i.test(h) && /gemstone|precious stones|jerusalem stones/i.test(h); }, 'Wood with Gemstones']
  ]},
  { name: 'Size', skip: /kosher parchment/i, rules: [
    [sz(0, 3.75), 'Small (under 3.5")'],
    [sz(3.75, 6), 'Medium (4-6")'],
    [sz(6, 99), 'Large (6"+)']
  ]},
  { name: 'Design / Symbol', skip: /kosher parchment/i, rules: [
    [L(/shema(?!\s+(?:israel\s+)?scroll)/i), 'Shema'],
    [L(/stars? of david|magen david/i), 'Star of David'],
    [L(/hams[ae]|hamesh/i), 'Hamsa'],
    [L(/jerusalem\s+(?:old city|panorama|view|flowers)|walls of old city|western wall/i), 'Jerusalem'],
    [L(/\b10 commandments|ten commandments/i), '10 Commandments'],
    [/\bcrown\b/i, 'Crown'],
    [L(/tree of life/i), 'Tree of Life'],
    [/12 tribes|twelve tribes|hoshen|breastplate/i, '12 Tribes'],
    [/elijah/i, 'Elijah']
  ]},
  { name: 'Quantity', one: true, rules: [
    [/\bset\b/i, 'Set (5 or 6 Pack)']
  ], fallback: 'Individual' }
  ];
})() };

/* Judaica — 137 products (data/judaica.json). Category from titles; Yair Emanuel art from vendor/title (multi-valued: a Yair Emanuel mezuzah is also a Mezuzah). */
R['judaica'] = { groups: [
  { name: 'Category', rules: [
    [function(h, p){ var t = p.title || ''; return /tallit|tallis|talit|prayer shawl/i.test(t) && !/tzitzit|\bbag\b/i.test(t); }, 'Tallit (Prayer Shawl)'],
    [/tzitzit|tassels?\b/i, 'Tzitzit (Prayer Fringes)'],
    [function(h, p){ return /kippah|kippa|kipa\b|yarmulke/i.test(p.title || ''); }, 'Kippah (Head Covering)'],
    [function(h, p){ return /mezuzah/i.test(p.title || ''); }, 'Mezuzah (Doorpost Scroll)'],
    [function(h, p){ var t = p.title || ''; return /menorah|hanukkiah/i.test(t) && !/mezuzah|\bcup\b|necklace/i.test(t); }, 'Menorah (Candelabra)'],
    [function(h, p){ return /ceramic|pottery/i.test(p.title || ''); }, 'Ceramic Judaica'],
    [function(h, p){ return /emanu[ae]l/i.test((p.title || '') + ' ' + (p.vendor || '')) || /by yair emanuel/i.test(String(p.body_html || '')); }, 'Art (Yair Emanuel)']
  ]}
]};

/* Kippahs — 22 products (data/kippahs.json). Material/size in titles (suede size only in the body); colors of knitted kippahs read from the title prefix. */
R['kippahs'] = { groups: (function(){
  /* the colour words at the start of a knitted-kippah title, before "17cm" */
  function colors(p){ return String(p.title || '').split(/\d+\s*cm/i)[0]; }
  return [
  { name: 'Material', rules: [
    [/knitted|cotton/i, 'Knitted Cotton'],
    [/satin/i, 'Satin'],
    [/suede/i, 'Suede'],
    [/leather/i, 'Leather']
  ]},
  { name: 'Style / Tradition', one: true, rules: [
    [/messiani?c/i, 'Messianic']
  ], fallback: 'Jewish/Traditional' },
  { name: 'Design', rules: [
    [/stars? of david|magen david/i, 'Star of David'],
    [function(h, p){ var c = colors(p); return /white/i.test(c) && /blue/i.test(c) && !/black|gr[ae]y|beige|colorful/i.test(c); }, 'Israeli Colors'],
    [/messiani?c\s+(?:sign|seal|symbol)/i, 'Messianic Symbol'],
    [/foil/i, 'Foil Embossed']
  ], fallback: 'Plain' },
  { name: 'Size', src: 'body', rules: [
    [/\b15\s*cm\b/i, '15 cm'],
    [/\b17\s*cm\b/i, '17 cm'],
    [/\b6\.5\s*(?:"|inch)/i, '6.5"']
  ]}
  ];
})() };

/* Kitchenware Cups — 18 products (data/kitchenware-cups.json). Material/use in titles; pack counts in the Count option; some designs only in descriptions. */
R['kitchenware-cups'] = { groups: [
  { name: 'Material', src: 'title', rules: [
    [/ceramic|armenian|pottery/i, 'Armenian Ceramic'],
    [/olive\s*wood/i, 'Olive Wood']
  ]},
  { name: 'Use / Function', rules: [
    [/^(?!.*(elijah|passover|seder)).*(communion|chalice)/i, 'Communion Cup'],
    [/kiddush|shabbat/i, 'Kiddush/Shabbat'],
    [/elijah|miriam|passover/i, 'Passover (Elijah/Miriam)'],
    [/coffee|teacup|ceramic cup - (small|meduim|medium)/i, 'Coffee/Tea'],
    [/goblet/i, 'Goblet'],
    [/\begg\b/i, 'Egg Cup']
  ]},
  { name: 'Design', src: 'body', rules: [
    [function(h, p){ return /tabgha|\bfish|loaves/i.test(p.title); }, 'Tabgha (Fish & Bread)'],
    [function(h, p){ return /shalom|peace|\bdove\b/i.test(p.title); }, 'Shalom (Dove)'],
    [/jerusalem flowers|jerusalem and floral/i, 'Jerusalem Flowers'],
    [/blue flower/i, 'Blue Flower'],
    [/borei pri/i, 'Borei Pri Hagafen'],
    [function(h, p){ return /olive\s*wood/i.test(p.title) && !/last supper/i.test(p.title); }, 'Natural Grain']
  ]},
  { name: 'Sold As', rules: [
    [/\b1 cup\b/i, 'Individual'],
    [/\bset\b|\bfour\b|\b(3|10|25|50|100) cups\b/i, 'Set (4-pack, 6-pack)'],
    [/plate|tray/i, 'With Plate']
  ], fallback: 'Individual' }
]};

/* Kitchenware Spoons & Scoops — 27 products (data/kitchenware-spoons-scoops.json). All olive wood; tool, set and length are in titles. */
R['kitchenware-spoons-scoops'] = { groups: [
  { name: 'Tool Type', src: 'title', rules: [
    [/cook'?s|cooking|risotto|terra collection/i, 'Cooking Spoon'],
    [/salt|scoop|spices spoon/i, 'Salt Scoop'],
    [/^(?!.*fork).*(serving|server)/i, 'Serving Spoon'],
    [/spatula/i, 'Spatula'],
    [/spaghetti/i, 'Spaghetti Spoon'],
    [/fork/i, 'Fork & Spoon Set'],
    [/ladle/i, 'Ladle']
  ]},
  { name: 'Sold As', src: 'title', rules: [
    [/\bset\b/i, 'Set (3-piece, 4-piece, 5-piece)']
  ], fallback: 'Individual' },
  { name: 'Size', src: 'title', rules: [
    [inch(0, 7.5), 'Small (under 6")'],
    [inch(7.5, 11), 'Medium (8-10")'],
    [/\(10, 12 and 14|10 12 and 13 inches/i, 'Medium (8-10")'],
    [inch(11, 99), 'Large (12"+)'],
    [/\b(1[1-9]|[2-9]\d)-inch/i, 'Large (12"+)']
  ]}
]};

/* Lamps & Candles — 26 products (data/lamps-candles.json). Type/material/era in titles; Herodian lamp sells Byzantine variants in its Color option. */
R['lamps-candles'] = { groups: [
  { name: 'Type', src: 'title', one: true, rules: [
    [/^(?!.*(anointing|wicks? and wax)).*\blamps?\b/i, 'Oil Lamp'],
    [/candle/i, 'Candle'],
    [/wicks? and wax/i, 'Accessory/Wicks & Wax'],
    [/anointing/i, 'Clay Jug with Anointing Oil']
  ]},
  { name: 'Material', src: 'title', rules: [
    [/clay|pottery|terra cotta|herodian/i, 'Clay/Pottery'],
    [/brass/i, 'Brass'],
    [/beeswax/i, 'Beeswax']
  ]},
  { name: 'Candle Type', src: 'title', rules: [
    [/7-hour/i, '7-Hour Church Candle'],
    [/2-hour/i, '2-Hour Candle'],
    [/easter|holy fire/i, 'Easter/Holy Fire'],
    [/orthodox/i, 'Orthodox Church Candle']
  ]},
  { name: 'Era / Style', skip: /candle|wicks? and wax/i, rules: [
    [/herodian|jesus time|animal wick/i, 'Herodian Replica'],
    [/byzantine/i, 'Byzantine Replica'],
    [/crusader|12th|13th century/i, 'Crusaders'],
    [/messianic/i, 'Messianic'],
    [/antique/i, 'Antique/Archaeological']
  ]}
]};

/* Beeswax Candles — 6 products (data/lc-beeswax-candles.json). Type/diameter in titles; pack counts in Size options/titles; colors in the Color option. */
R['lc-beeswax-candles'] = { groups: [
  { name: 'Candle Type', src: 'title', one: true, rules: [
    [/7-hour/i, '7-Hour Church Candle'],
    [/2-hour/i, '2-Hour Thin Candle'],
    [/orthodox church/i, 'Orthodox Church (3/8")'],
    [/easter|holy fire/i, 'Easter/Holy Fire']
  ]},
  { name: 'Diameter', src: 'title', rules: [
    [/\b1\/4("|\s*inch)/i, '1/4"'],
    [/\b3\/8("|\s*inch)/i, '3/8"'],
    [/\b3\/4("|\s*inch)/i, '3/4"']
  ]},
  { name: 'Pack Size', src: 'body', rules: [
    [/\b3 candles|you get three candles/i, '3 candles'],
    [/\b6 candles/i, '6 candles'],
    [/\b12 candles/i, '12 candles'],
    [function(h, p){ return /\b33 candles/i.test(p.title); }, '33 candles'],
    [/kilogram|\b1 kg/i, '1 kg Bulk']
  ]},
  { name: 'Color', src: 'opt', opt: /colou?r/i, rules: [
    [/black/i, 'Black'],
    [/brown/i, 'Brown'],
    [/burgundy/i, 'Burgundy'],
    [/green/i, 'Green'],
    [/honey/i, 'Honey'],
    [/yellow/i, 'Yellow (Easter candles only)']
  ]}
]};

/* Messianic Mezuzahs — 9 products (data/messianic-mezuzahs.json). Material/size in titles (one size only in the body). */
R['messianic-mezuzahs'] = { groups: (function(){
  var KLAF = /(?:fits?|up to)\s+(?:up to\s+)?[\d.\/]+\s*(?:inch(?:es)?|")\s*klaf|\(?cavity[^)]*\)?/i;
  function body(p){ return String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ').replace(/\s+/g, ' '); }
  function T(re){ return function(h, p){ return re.test(p.title || ''); }; }
  function sz(lo, hi){ var f = inch(lo, hi), any = inch(0, 999); return function(h, p){
    h = h.split(KLAF).join(' ');
    if (!any(h)) { var m = body(p).match(/measuring\s+(?:about\s+)?[\d.]+\s*(?:cm|inch(?:es)?)\b/i); h = m ? m[0] : ''; }
    return f(h); }; }
  return [
  { name: 'Material', rules: [
    [/olive\s*wood/i, 'Olive Wood'],
    [function(h, p){ return /colou?red metal/i.test(body(p).slice(0, 220)); }, 'Colored Metal'],
    [T(/bronze/i), 'Bronze'],
    [T(/brass/i), 'Brass'],
    [/jerusalem stones/i, 'Wood with Jerusalem Stones']
  ]},
  { name: 'Size', skip: /kosher parchment/i, rules: [
    [sz(0, 4), 'Small (under 4")'],
    [sz(4, 5.9), 'Medium (4-5.8")'],
    [sz(5.9, 99), 'Large (6"+)']
  ]},
  { name: 'Use / Placement', skip: /kosher parchment/i, one: true, rules: [
    [T(/standing|table\s*top|desk/i), 'Tabletop/Standing'],
    [T(/\bbox\b/i), 'Decorative Box'],
    [T(/mezuzah/i), 'Doorpost']
  ]}
  ];
})() };

/* Messianic Tallits — 17 products (data/messianic-tallits.json). Colors in Color options or titles; sizes as "72 x 32" or Size options (bucketed on the narrow side). */
R['messianic-tallits'] = { groups: (function(){
  function dims(s){
    var out = [], m, re = /(\d{2}(?:\.\d+)?)\s*(?:"|''|\u201d)?\s*(?:L\b|long\b|inch(?:es)?\b)?\s*(?:x|\/|and)\s*(\d{2}(?:\.\d+)?)/i;
    while ((m = re.exec(s))) { out.push(Math.min(+m[1], +m[2])); s = s.slice(m.index + m[0].length); }
    return out;
  }
  function sizes(h, p){
    var out = [], d = dims(h), m;
    (p.options || []).forEach(function(o){
      if (!/size/i.test(o.name || '')) return;
      (o.values || []).forEach(function(v){
        if (/\bsmall\b/i.test(v)) out.push('S');
        if (/\bmedium\b/i.test(v)) out.push('M');
        if (/\blarge\b/i.test(v)) out.push('L');
      });
    });
    if (!d.length && !out.length){
      m = String(p.body_html || '').replace(/<[^>]+>/g, ' ').match(/(\d{2})\s*x\s*(\d{2})\s*(?:"|inch|pulgadas)/i);
      if (m) d.push(Math.min(+m[1], +m[2]));
    }
    d.forEach(function(x){ out.push(x < 23 ? 'S' : x < 35 ? 'M' : 'L'); });
    return out;
  }
  function S(k){ return function(h, p){ return sizes(h, p).indexOf(k) !== -1; }; }
  var NOT_TALLIT = /\bbag\b|tzitzit/i;
  return [
  { name: 'Size', skip: NOT_TALLIT, rules: [
    [S('S'), 'Small (72x22")'],
    [S('M'), 'Medium (72x32")'],
    [S('L'), 'Large (80x60")']
  ]},
  { name: 'Color', src: 'opt', opt: /colou?r/i, skip: NOT_TALLIT, rules: [
    [/black/i, 'Black'],
    [/navy|dark[\s-]*blue/i, 'Navy'],
    [/purple|lavender/i, 'Purple'],
    [/\bred\b/i, 'Red'],
    [/royal[\s-]*blue/i, 'Royal Blue'],
    [/sky[\s-]*blue|light[\s-]*blue/i, 'Sky Blue'],
    [/gold/i, 'Gold'],
    [/silver/i, 'Silver'],
    [/pink/i, 'Pink'],
    [/green/i, 'Green'],
    [/white/i, 'White']
  ]},
  { name: 'Design / Style', src: 'title', skip: NOT_TALLIT, rules: [
    [/messiah tallit/i, 'Messiah Tallit'],
    [/grafted/i, 'Grafted In'],
    [/new covenant/i, 'New Covenant'],
    [/purple\s*(?:with|&|and|\/)\s*gold/i, 'Purple & Gold'],
    [/spanish|esquinas|espa.?olas/i, 'Spanish Corners']
  ]},
  { name: 'Bundle', skip: NOT_TALLIT, rules: [
    [/tallit with kippah|tallit con kippah/i, 'Tallit With Kippah'],
    [/tallit only/i, 'Tallit Only']
  ], fallback: 'Tallit Only' }
  ];
})() };

/* Messianic — 46 products (data/messianic.json). Type from titles; colors in Color options or titles; bundle/gender only for tallits & kippahs. */
R['messianic'] = { groups: (function(){
  function T(re, not){ return function(h, p){ var t = p.title || ''; return re.test(t) && !(not && not.test(t)); }; }
  var NOT_TALLIT = /^(?![\s\S]*(?:tallit|tallis|talit|prayer shawl))|\bbag\b|tzitzit/i;
  var NOT_WEAR = /^(?![\s\S]*(?:tallit|tallis|talit|prayer shawl|kippah))|\bbag\b|tzitzit/i;
  return [
  { name: 'Product Type', one: true, rules: [
    [T(/tallit|tallis|talit|prayer shawl/i, /tzitzit|\bbag\b/i), 'Tallit'],
    [T(/tzitzit|tassels?\b/i), 'Tassel/Tzitzit'],
    [T(/kippah/i), 'Kippah'],
    [T(/mezuzah/i), 'Mezuzah'],
    [T(/banner/i), 'Banner'],
    [T(/olive\s*wood/i), 'Olive Wood Gift']
  ]},
  { name: 'Color', src: 'opt', opt: /colou?r/i, skip: /\bbag\b|olive\s*wood|bible|stone|kosher parchment/i, rules: [
    [/black/i, 'Black'],
    [/navy|dark[\s-]*blue/i, 'Navy'],
    [/purple|lavender/i, 'Purple'],
    [/\bred\b/i, 'Red'],
    [/royal[\s-]*blue/i, 'Royal Blue'],
    [/sky[\s-]*blue|light[\s-]*blue/i, 'Sky Blue'],
    [/gold/i, 'Gold'],
    [/silver/i, 'Silver'],
    [/pink/i, 'Pink'],
    [/green/i, 'Green'],
    [/white/i, 'White']
  ]},
  { name: 'Bundle', skip: NOT_TALLIT, rules: [
    [/tallit with kippah|tallit con kippah/i, 'Tallit With Kippah'],
    [/tallit only/i, 'Tallit Only']
  ], fallback: 'Tallit Only' },
  { name: 'Gender', src: 'title', skip: NOT_WEAR, rules: [
    [/\bmen'?s\b|\bmen\b/i, "Men's"],
    [/\bwomen'?s\b|\bwomen\b|\bladies\b/i, "Women's"]
  ], fallback: 'Unisex' }
  ];
})() };

/* Mezuzahs — 57 products (data/mezuzahs.json). Material/size in titles; design partly in the first body sentence ("Comes with ... engraved"). */
R['mezuzahs'] = { groups: (function(){
  var KLAF = /(?:fits?|up to)\s+(?:up to\s+)?[\d.\/]+\s*(?:inch(?:es)?|")\s*klaf|\(?cavity[^)]*\)?/i;
  function body(p){ return String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ').replace(/\s+/g, ' '); }
  function lead(p){ return body(p).slice(0, 220); }
  function L(re){ return function(h, p){ return re.test(h + ' | ' + lead(p)); }; }
  function sz(lo, hi){ var f = inch(lo, hi), any = inch(0, 999); return function(h, p){
    h = h.split(KLAF).join(' ');
    if (!any(h)) { var m = body(p).match(/measuring\s+(?:about\s+)?[\d.]+\s*(?:cm|inch(?:es)?)\b/i); h = m ? m[0] : ''; }
    return f(h); }; }
  return [
  { name: 'Style / Tradition', one: true, rules: [
    [/messiani?c/i, 'Messianic']
  ], fallback: 'Jewish/Traditional' },
  { name: 'Material', rules: [
    [/olive\s*wood/i, 'Olive Wood'],
    [function(h, p){ return /gold[\s-]*plated|silver[\s-]*plated|\bmetal\b(?!\s+plate)/i.test(h) || /colou?red metal/i.test(lead(p)) || (/\bcrown mezuzah\b/i.test(p.title) && /gold|silver/i.test(h)); }, 'Metal (Gold/Silver Plated)'],
    [/bronze|brass/i, 'Bronze'],
    [/pewter/i, 'Pewter'],
    [/copper/i, 'Copper'],
    [function(h){ return /wood/i.test(h) && /gemstone|precious stones|jerusalem stones/i.test(h); }, 'Wood with Gemstones']
  ]},
  { name: 'Size', skip: /kosher parchment/i, rules: [
    [sz(0, 3.75), 'Small (under 3.5")'],
    [sz(3.75, 6), 'Medium (4-6")'],
    [sz(6, 99), 'Large (6"+)']
  ]},
  { name: 'Design / Symbol', skip: /kosher parchment/i, rules: [
    [L(/messiani?c seal/i), 'Messianic Seal'],
    [L(/stars? of david|magen david/i), 'Star of David'],
    [L(/shema(?!\s+(?:israel\s+)?scroll)/i), 'Shema'],
    [L(/jerusalem\s+(?:old city|panorama|view|flowers)|walls of old city|western wall/i), 'Jerusalem'],
    [L(/hams[ae]|hamesh/i), 'Hamsa'],
    [L(/\b10 commandments|ten commandments/i), '10 Commandments'],
    [/\bcrown\b/i, 'Crown'],
    [L(/tree of life/i), 'Tree of Life']
  ]}
  ];
})() };

/* Olive Wood Bibles — 10 products (HLF/data/olive-wood-bibles.json). Titles only (tags wrongly say KJV on Jerusalem Bibles). */
R['olive-wood-bibles'] = { groups: [
  { name: 'Bible Edition', src: 'title', one: true, rules: [
    [/king james|\bkjv\b/i, 'King James Version (KJV)'],
    [/jerusalem bible/i, 'Jerusalem Bible'],
    [/good news|catholic edition/i, 'Good News / Catholic Edition']
  ]},
  { name: 'Cover Design', src: 'title', rules: [
    [/lord.?s prayer/i, "Lord's Prayer"],
    [/last supper/i, 'Last Supper'],
    [/messianic seal/i, 'Messianic Seal'],
    [/holy sepulchre/i, 'Holy Sepulchre'],
    [/\bdove\b/i, 'Dove & Jerusalem'],
    [/crucifixion/i, 'Crucifixion'],
    [/stations of the cross/i, 'Stations of Cross']
  ]},
  { name: 'Style / Tradition', src: 'title', rules: [
    [/king james|\bkjv\b|protestant/i, 'Protestant'],
    /* Jerusalem Bible = Catholic translation; Messianic-seal covers are listed under Messianic only */
    [function(h){ return /catholic|good news/i.test(h) || (/jerusalem bible/i.test(h) && !/messianic/i.test(h)); }, 'Catholic'],
    [/messianic/i, 'Messianic']
  ]},
  { name: 'Cover Material', src: 'title', rules: [
    [/olive wood/i, 'Olive Wood'],
    [/mother of pearl/i, 'Mother of Pearl']
  ]}
]};

/* Olive Wood Crosses & Crucifixes — 195 products (HLF/data/olive-wood-crosses-crucifixes.json). Type/size in titles + Size options; pack counts in Count/Unit Count/Pack options or title words. */
R['olive-wood-crosses-crucifixes'] = { groups: [
  /* title + description only (the shared SEO tags would add Christmas etc. everywhere) */
  { name: 'Occasion', rules: [
    [function(h, p){ return /baptisms?\b(?! of (jesus|christ|our lord))/i.test(p.title + ' ' + (p.body_html || '')); }, 'Baptism'],
    [function(h, p){ return /first communion/i.test(p.title + ' ' + (p.body_html || '')); }, 'First Communion'],
    [function(h, p){ return /confirmation/i.test(p.title + ' ' + (p.body_html || '')); }, 'Confirmation'],
    [function(h, p){ return /\beaster\b/i.test(p.title + ' ' + (p.body_html || '')); }, 'Easter'],
    [function(h, p){ return /christmas/i.test(p.title + ' ' + (p.body_html || '')); }, 'Christmas'],
    [function(h, p){ return /bereave|sympathy|funeral|memorial|\bgrief|\bloss\b|in memory/i.test(p.title + ' ' + (p.body_html || '')); }, 'Memorial / Sympathy'],
    [function(h, p){ return /wedding|bridal/i.test(p.title + ' ' + (p.body_html || '')); }, 'Wedding']
  ]},
  /* priority: hand-held > crucifix > plain wall cross (table-only plain crosses get no value) */
  { name: 'Cross Type', src: 'title', one: true, rules: [
    [/^(?!.*priest).*(pocket|comfort|holding|hand ?held|hand cross|palm cross|fidget|worry|thumb|healing cross|hand fit|sit in your hand)/i, 'Pocket/Comfort/Holding Cross'],
    [function(h){ return !/^(?!.*priest).*(pocket|comfort|holding|hand ?held|hand cross|palm cross|fidget|worry|thumb|healing cross|hand fit|sit in your hand)/i.test(h) && !/crucifix|corpus/i.test(h) && !/priest hand held|blessing hand eastern/i.test(h) && (/hang|wall/i.test(h) || !/table|standing|altar/i.test(h)); }, 'Wall Cross'],
    [/crucifix|corpus/i, 'Crucifix (with Figure)']
  ]},
  { name: 'Quantity', src: 'opt', opt: /count|quantity|pack/i, rules: [
    [function(h, p){ return h !== p.title && /^\s*1(\s*count)?\s*$/i.test(h); }, 'Single'],
    [function(h, p){ var n = parseInt(h, 10); return h === p.title ? /^(holy land market )?(pair of|two|three) (?!tones?\b|layers?\b|colou?rs?\b|bar\b)/i.test(h) : (n >= 2 && n <= 5); }, 'Small Pack (2-5)'],
    [function(h, p){ var n = parseInt(h, 10); return h === p.title ? /^(holy land market )?(six|ten|10) (?!tones?\b|layers?\b)/i.test(h) : (n >= 6 && n <= 10); }, 'Medium Pack (6-10)'],
    /* 20-count packs go here too (spec buckets jump from 10 to 25) */
    [function(h, p){ var n = parseInt(h, 10); return h === p.title ? /one thousand|\(1000\)/i.test(h) : n > 10; }, 'Bulk (25+)']
  ], fallback: 'Single' },
  { name: 'Size', src: 'opt', opt: /size/i,
    skip: /^(?!.*priest).*(pocket|comfort|holding|hand ?held|hand cross|palm cross|fidget|worry|thumb|healing cross|hand fit|sit in your hand)/i,
    rules: [
    [inch(3.5, 5.75), '4-5"'],
    [inch(5.75, 9), '6-8"'],
    /* 9" sits between the spec's 6-8" and 10-14": it goes to the larger bucket */
    [inch(9, 16.5), '10-14" (wall crosses only)'],
    [/nine inch/i, '10-14" (wall crosses only)']
  ]}
]};

/* Olive Wood Icons — 33 products (HLF/data/olive-wood-icons.json). Subject + size in titles / Size option; gold in titles. */
R['olive-wood-icons'] = { groups: [
  { name: 'Subject', src: 'title', rules: [
    [/jesus christ|pantocrator|\bchrist life\b|teach us how to pray/i, 'Jesus Christ'],
    [/holy family/i, 'Holy Family'],
    [/nativity/i, 'Nativity'],
    [/last supper/i, 'Last Supper'],
    [/virgin mary|our lady|blessed mother/i, 'Virgin Mary/Our Lady'],
    [/john the baptist/i, 'John the Baptist'],
    [/tree of life/i, 'Tree of Life'],
    [/crucifixion/i, 'Crucifixion'],
    [/annunciation/i, 'Annunciation']
  ]},
  { name: 'Size', src: 'opt', opt: /size/i, rules: [
    /* no size in title/options -> read it from the description */
    [function(h, p){ return inch(0, 4)(h) || (!inch(0, 9999)(h) && inch(0, 4)(String(p.body_html || '').replace(/<[^>]+>/g, ' '))); }, 'Mini (under 4")'],
    [function(h, p){ return inch(4, 7)(h) || (!inch(0, 9999)(h) && inch(4, 7)(String(p.body_html || '').replace(/<[^>]+>/g, ' '))); }, 'Small (4-7")'],
    [function(h, p){ return inch(7, 10.1)(h) || (!inch(0, 9999)(h) && inch(7, 10.1)(String(p.body_html || '').replace(/<[^>]+>/g, ' '))); }, 'Medium (7-10")'],
    [function(h, p){ return inch(10.1, 14)(h) || (!inch(0, 9999)(h) && inch(10.1, 14)(String(p.body_html || '').replace(/<[^>]+>/g, ' '))); }, 'Large (10-14")'],
    [function(h, p){ return inch(14, 999)(h) || (!inch(0, 9999)(h) && inch(14, 999)(String(p.body_html || '').replace(/<[^>]+>/g, ' '))); }, 'Extra Large (14"+)']
  ]},
  { name: 'Gold Detail', src: 'title', one: true, rules: [
    [/gold/i, 'With 24K Gold']
  ], fallback: 'Without Gold' }
]};

/* Olive Wood Last Supper Sets — 11 products (HLF/data/olive-wood-last-supper-sets.json). Everything is in titles. */
R['olive-wood-last-supper-sets'] = { groups: [
  { name: 'Product Type', src: 'title', one: true, rules: [
    [/goblet|chalice|\bcup\b/i, 'Goblet/Chalice'],
    [/last supper|plaque|carv/i, 'Wall Plaque/Carving']
  ]},
  { name: 'Style', src: 'title', skip: /goblet|chalice|\bcup\b/i, rules: [
    [/modern|abstract/i, 'Modern/Abstract'],
    [/\bround\b/i, 'Round'],
    [/framed|frame/i, 'Framed (Silver/Mahogany)']
  ], fallback: 'Traditional' },
  { name: 'Material Accent', src: 'title', rules: [
    [/alabaster/i, 'Alabaster Figures'],
    [/silver/i, 'Silver Frame']
  ], fallback: 'Plain Olive Wood' }
]};

/* Olive Wood Magnets — 31 products (HLF/data/olive-wood-magnets.json). Theme + features in titles only. */
R['olive-wood-magnets'] = { groups: [
  { name: 'Theme', src: 'title', skip: /hanging frame/i, rules: [
    [/prayer|god bless|pray for/i, 'Prayer & Scripture'],
    [/jesus|ichthys|crucifixion/i, 'Jesus / Christ'],
    [/cross/i, 'Cross & Jerusalem Cross'],
    [/saint|charbel/i, 'Saints'],
    [/nativity|flight to egypt|shepherd|^bethlehem magnet/i, 'Nativity & Holy Family'],
    [function(h){ return /jaffa gate|jerusalem(?! cross| olive)/i.test(h) && !/peace of jerusalem/i.test(h); }, 'Jerusalem Landmarks'],
    [/miracle|crucifixion|flight to egypt/i, 'Bible Scenes / Miracles']
  ]},
  { name: 'Special Feature', src: 'title', rules: [
    [/mother of pearl/i, 'Mother of Pearl Inlay'],
    [/magnet decoration|ornament/i, 'Dual Magnet+Ornament']
  ], fallback: 'No Special Feature' }
]};

/* Olive Wood Nativity Sets & Figures — 31 products (HLF/data/olive-wood-nativity-sets-figures.json). Style/format from titles + specific description phrases (descriptions cross-link other sets, so only tight phrases are read). */
R['olive-wood-nativity-sets-figures'] = { groups: [
  { name: 'Style', src: 'body', rules: [
    [function(h, p){ return /traditional|antique/i.test(p.title) || (!/modern|abstract|faceless/i.test(p.title) && /12-piece traditional|traditional carving|popular traditional design/i.test(String(p.body_html || ''))); }, 'Traditional/Antique'],
    [function(h, p){ return /modern|abstract|faceless|\bblind\b/i.test(p.title); }, 'Modern/Abstract'],
    [/rustic|olive tree bark|bark roof/i, 'Rustic'],
    [/village/i, 'Village Scene']
  ]},
  { name: 'Format', src: 'body', one: true, skip: /one piece/i, rules: [
    [function(h, p){ return /baby jesus (with|in) cradle/i.test(p.title); }, 'Individual Figure'],
    [function(h, p){ return /miniature|3 inches tallest/i.test(p.title); }, 'Miniature'],
    [function(h, p){ return /stable|cave/i.test(p.title) || /stable measures|the stable (is|has|that comes|can be)|comes complete with a stable|in addition to the stable|attached to the stable|collapsible (olive wood )?stable|musical house/i.test(String(p.body_html || '')); }, 'Full Set with Stable'],
    [/\b\d+[- ]?(piece|pieces|pcs)\b|set of \d+/i, 'Full Set (No Stable)']
  ]},
  /* "Small (5-8 Inches)" / "Large (8-12 Inches)" option labels are read as labels, not as measurements */
  { name: 'Size', src: 'opt', opt: /size/i, rules: [
    [function(h){ return /small \(5-8/i.test(h) || (!/\(\d+-\d+ inch/i.test(h) && inch(4.5, 8)(h)); }, 'Small (5-8")'],
    [function(h){ return /large \(8-12/i.test(h) || (!/\(\d+-\d+ inch/i.test(h) && inch(8, 999)(h)); }, 'Large (8-12")']
  ]}
]};

/* Olive Wood Ornaments — 81 products (HLF/data/olive-wood-ornaments.json). Titles first; the description's opening line fills gaps (LEAD = first 200 chars, cross-links come later). */
R['olive-wood-ornaments'] = { groups: [
  { name: 'Shape', src: 'title', rules: [
    /* flat ornaments with a bell-shaped design stay under Flat only */
    [function(h, p){ return !/\bflat\b/i.test(h) && /\bbells?\b/i.test(h + ' ' + String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 200)); }, 'Bell'],
    [function(h, p){ return /heart/i.test(h + ' ' + String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 200)); }, 'Heart'],
    [function(h, p){ var t = h + ' ' + String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 200); return /\bflat\b/i.test(t) && !/\b3-?d\b|three dimension/i.test(t); }, 'Flat']
  ]},
  /* title decides; the description is read only when the title says neither */
  { name: 'Style', src: 'title', one: true, rules: [
    [/laser/i, 'Modern/Laser'],
    [/hand[- ]?(carved|made|crafted)|carved by hand|antique|vintage|\bbark\b|saw hand/i, 'Antique/Vintage (hand-carved)'],
    [function(h, p){ return /laser/i.test(String(p.body_html || '')); }, 'Modern/Laser'],
    [function(h, p){ return /hand[- ]?(carved|made|crafted)|carved by hand|scroll saw|made by saw/i.test(String(p.body_html || '')); }, 'Antique/Vintage (hand-carved)']
  ]},
  { name: 'Subject', src: 'title', rules: [
    [function(h, p){ return /nativity|manger|cradle/i.test(h + ' ' + String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 200)); }, 'Nativity Scene'],
    [function(h, p){ return /holy family|flight to egypt/i.test(h + ' ' + String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 200)); }, 'Holy Family'],
    [function(h, p){ return /mother mary|mary with|madonna|virgin and child/i.test(h + ' ' + String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 200)); }, 'Mary & Baby Jesus'],
    [function(h, p){ return /magi|wise men|kings (of|from) the east|offering (the )?gifts/i.test(h + ' ' + String(p.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').slice(0, 200)); }, 'Magi/Wise Men']
  ]},
  { name: 'Format', src: 'title', one: true, rules: [
    [/7-piece|seven piece/i, 'Set (7-piece)'],
    [/set of 12|12 flat/i, 'Set (12-piece)'],
    /* multi-packs that are neither 7 nor 12 pieces (pairs, fours, 3/6 bells, 5-bell set, 10-mix, collection) get no Format value */
    [function(h){ return !/\bpair\b|\bfour\b|^10 |collection|\bmix\b|small bells|tree hanging bells|bell ornaments\s+\(2\.75" each\)/i.test(h); }, 'Single']
  ]}
]};

/* Olive Wood Pen Blanks & Pens — 8 products (HLF/data/olive-wood-pen-blanks-pens.json). Titles only. */
R['olive-wood-pen-blanks-pens'] = { groups: [
  { name: 'Product Type', src: 'title', one: true, rules: [
    [/pen blanks?/i, 'Raw Pen Blank (for Woodturning)'],
    [/ballpoint|\bpen\b/i, 'Finished Ballpoint Pen']
  ]},
  { name: 'Quantity', src: 'title', one: true, rules: [
    [/\bfive\b|\b5 pc/i, '5-Pack'],
    [/set of 8|\b8 pc/i, '8-Pack (blanks only)'],
    /* 10-pack of blanks has no matching spec value -> left blank */
    [function(h){ return !/^10 /i.test(h); }, 'Single']
  ]},
  { name: 'Engraving', src: 'title', one: true, rules: [
    [/engraved with bethlehem/i, 'Bethlehem'],
    [/engraved with jerusalem/i, 'Jerusalem'],
    [/shalom y.?all/i, "Shalom Y'All (pens only)"]
  ], fallback: 'No Engraving' }
]};

/* Olive Wood (parent, ~608 products). Everything here is olive wood, so no material group.
   Approved values come from the store's own sub-collections (built into the map);
   these title rules only cover products the map doesn't list yet. */
R['olive-wood'] = { groups: [
  { name: 'Category', src: 'title', one: true,
    order: ['Crosses & Crucifixes', 'Necklaces & Pendants', 'Ornaments', 'Statues & Angels', 'Nativity Sets', 'Magnets',
            'Last Supper', 'Bibles', 'Rosary Boxes', 'Plaques', 'Bracelets', 'Pens & Pen Blanks', 'Key Chains', 'Kitchenware'],
    rules: [
    [/key ?chain|keys? ?ring/i, 'Key Chains'],
    [/bracelet/i, 'Bracelets'],
    [/necklace|pendant|\(\d+ ?cm \/ [\d.]+/i, 'Necklaces & Pendants'],
    [/magnet/i, 'Magnets'],
    [/ornament/i, 'Ornaments'],
    [/rosary box|jewelry box|wooden box/i, 'Rosary Boxes'],
    [/last supper/i, 'Last Supper'],
    [/\bbible\b/i, 'Bibles'],
    [/pen blank|\bpens?\b/i, 'Pens & Pen Blanks'],
    [/plaque/i, 'Plaques'],
    [/nativity|manger|stable/i, 'Nativity Sets'],
    [/statue|figurine|angel|praying hands|sculpture/i, 'Statues & Angels'],
    [/cross|crucifix/i, 'Crosses & Crucifixes'],
    [/spoon|ladle|bowl|plate|kitchen|board/i, 'Kitchenware']
  ]},
  { name: 'Occasion', src: 'title', rules: [
    [/baptism|christening/i, 'Baptism'],
    [/first (holy )?communion/i, 'First Communion'],
    [/confirmation/i, 'Confirmation'],
    [/easter/i, 'Easter'],
    [/christmas/i, 'Christmas'],
    [/wedding/i, 'Wedding'],
    [/godparent|godmother|godfather/i, 'Godparent Gift']
  ]}
]};

/* Rosaries — 449 products (HLF/data/rosaries.json); ~340 are rosary-making supplies/accessories: the long skip regex = "title is not a finished rosary/chaplet/prayer rope". */
R['rosaries'] = { groups: [
  /* title + description only (the shared SEO tags list "Christmas" on many products) */
  { name: 'Occasion', rules: [
    [function(h, p){ return /baptism gift|christening|for (a |your )?baptism/i.test(p.title + ' ' + (p.body_html || '')); }, 'Baptism'],
    [function(h, p){ return /first communion/i.test(p.title + ' ' + (p.body_html || '')); }, 'First Communion'],
    [function(h, p){ return /confirmation/i.test(p.title + ' ' + (p.body_html || '')); }, 'Confirmation'],
    [function(h, p){ return /\beaster\b/i.test(p.title + ' ' + (p.body_html || '')); }, 'Easter'],
    [function(h, p){ return /christmas/i.test(p.title + ' ' + (p.body_html || '')); }, 'Christmas'],
    [function(h, p){ return /memorial|sympathy|bereave|funeral|in memory of/i.test(p.title + ' ' + (p.body_html || '')); }, 'Memorial / Sympathy'],
    [function(h, p){ return /wedding|bridal/i.test(p.title + ' ' + (p.body_html || '')); }, 'Wedding']
  ]},
  { name: 'Material / Bead Type', hide: ['Wooden Beads (Other)'], src: 'title',
    skip: /^(?!.*(habit priest|crystals rosary|wooden rosary with|threaded olive wood rosary))(?:(?!.*(rosar(y|ies)|chaplet|chotki|komboskini|prayer rope|bracelet))|.*((\(|\b)(60|500|1000)\s*(pcs|beads)|beads?\s*\((60|500|1000)|\(\d+[- ]*(beads|piece)|\b60 round beads|rosary (crucifix|cross)|crucifix\s*[-(\/]|crucifix with|rosary triangle|rosary\/pendant|rosary center \d|\bcenter\s*[-(]|center piece|center or triangle|medal\s*[-(]|laser|threading tool|rosary supplies|aroma - |keys ring))/i,
    rules: [
    /* description counts too (some olive wood rosaries don't say so in the title), minus cross-link sentences and link text */
    [function(h, p){ return /olive ?wood|olvie wood/i.test(h + ' ' + String(p.body_html || '').split(/<a\b[^>]*>[\s\S]*?<\/a>/i).join(' ').split(/<[^>]+>/).join(' ').split(/[.!?]\s/).filter(function(s){ return !/browse|other material|we do carry/i.test(s); }).join(' ')); }, 'Olive Wood'],
    [/crystal/i, 'Crystal (Swarovski)'],
    [/pearl|m\.o\.p/i, 'Pearl (MOP/Freshwater/Synthetic)'],
    [/hematite|malachite|onyx|amethyst|lapis|lapez|quartz|stones?\b|habit priest|medjugorje|medugorje/i, 'Stone (Hematite/Malachite/Onyx/Amethyst)'],
    [/glass/i, 'Glass'],
    [/sterling|silver tone[^,(]{0,30}beads|silver tone (crosses|icons)/i, 'Silver/Sterling Silver'],
    [/scented/i, 'Scented Wood'],
    [/petals?\b/i, 'Floral Petals'],
    [/wool|knotted/i, 'Wool/Knotted'],
    /* added: ~16 finished rosaries are plain (non-olive) wooden beads */
    [function(h, p){ return /wood|missionary/i.test(h) && !/scented/i.test(h) && !/olive ?wood|olvie wood/i.test(h + ' ' + String(p.body_html || '').split(/<a\b[^>]*>[\s\S]*?<\/a>/i).join(' ').split(/<[^>]+>/).join(' ').split(/[.!?]\s/).filter(function(s){ return !/browse|other material|we do carry/i.test(s); }).join(' ')); }, 'Wooden Beads (Other)']
  ]},
  { name: 'Rosary Type', src: 'title', one: true,
    skip: /^(?!.*(habit priest|crystals rosary|wooden rosary with|threaded olive wood rosary))(?:(?!.*(rosar(y|ies)|chaplet|chotki|komboskini|prayer rope|bracelet))|.*((\(|\b)(60|500|1000)\s*(pcs|beads)|beads?\s*\((60|500|1000)|\(\d+[- ]*(beads|piece)|\b60 round beads|rosary (crucifix|cross)|crucifix\s*[-(\/]|crucifix with|rosary triangle|rosary\/pendant|rosary center \d|\bcenter\s*[-(]|center piece|center or triangle|medal\s*[-(]|laser|threading tool|rosary supplies|aroma - |keys ring))/i,
    rules: [
    [/^(?!.*(finger|wall rosary|chaplet|byzantine|bracelet|chotki|komboskini|komvo|prayer rope|anglican)).*rosar/i, 'Full/Traditional'],
    [/finger/i, 'Finger Rosary'],
    [/wall rosary/i, 'Wall Rosary'],
    [/^(?!.*(chotki|komboskini|komvo|prayer rope)).*(chaplet|byzantine|rosary.*bracelet)/i, 'Chaplet/Byzantine'],
    [/chotki|komboskini|komvo|prayer rope/i, 'Komboskini/Chotki']
  ]},
  { name: 'Style / Tradition', src: 'title',
    skip: /^(?!.*(habit priest|crystals rosary|wooden rosary with|threaded olive wood rosary))(?:(?!.*(rosar(y|ies)|chaplet|chotki|komboskini|prayer rope|bracelet))|.*((\(|\b)(60|500|1000)\s*(pcs|beads)|beads?\s*\((60|500|1000)|\(\d+[- ]*(beads|piece)|\b60 round beads|rosary (crucifix|cross)|crucifix\s*[-(\/]|crucifix with|rosary triangle|rosary\/pendant|rosary center \d|\bcenter\s*[-(]|center piece|center or triangle|medal\s*[-(]|laser|threading tool|rosary supplies|aroma - |keys ring))/i,
    rules: [
    [/^(?!.*(orthodox|chotki|komboskini|komvo|prayer rope|anglican))/i, 'Catholic'],
    [/orthodox|chotki|komboskini|komvo|prayer rope/i, 'Orthodox'],
    [/medjugorje|medugorje|medugorie/i, 'Medjugorje']
  ]}
]};

/* Rosary Olive Wood — 36 products (HLF/data/rosary-olive-wood.json). Element/center from title + own-description sentences (cross-link "browse ..." sentences ignored). */
R['rosary-olive-wood'] = { groups: [
  /* the two "Jerusalem Cross center OR Soil center" listings are ambiguous -> no value */
  { name: 'Holy Land Element', src: 'title', skip: /large praying hands|hematite beads necklace/i, rules: [
    [function(h, p){ return /soil|holy land earth|holy earth/i.test(h + ' ' + String(p.body_html || '').split(/<[^>]+>/).join(' ').split(/[.!?]\s/).filter(function(s){ return !/browse|sample gift/i.test(s); }).join(' ')); }, 'Holy Land Soil'],
    [function(h, p){ return /jordan (river )?water|water from the (river )?jordan/i.test(h + ' ' + String(p.body_html || '').split(/<[^>]+>/).join(' ').split(/[.!?]\s/).filter(function(s){ return !/browse/i.test(s); }).join(' ')); }, 'Jordan River Water'],
    [/lourdes/i, 'Lourdes Holy Water']
  ], fallback: 'No Holy Land Element' },
  { name: 'Rosary Type', one: true, rules: [
    [/anglican/i, 'Anglican Rosary'],
    [/finger|chaplet|ten beads|decade/i, 'Finger Rosary/Chaplet']
  ], fallback: 'Full/Traditional Rosary' },
  { name: 'Center / Cross', src: 'body', rules: [
    [/jerusalem cross (rosary|olive wood rosary|center(?! instead)|centre|centerpiece|- cert)|with jerusalem cross|center is a jerusalem cross|centerpiece (displays|has) the jerusalem cross|jerusalem cross with jerusalem engraved/i, 'Jerusalem Cross Center'],
    [/enameled cross shaped center/i, 'Standard Cross Center'],
    [/praying hands/i, 'Praying Hands Center'],
    [/holy image|saint image|saint benedict center|center shows mother mary/i, 'Holy Image/Icon Center']
  ]},
  { name: 'Bead Style', src: 'body', rules: [
    [function(h){ return !/crystal|hematite|silver tone|pewter cross icon metal beads|quartz|lap[ie]z|lapis|amber|coral|enamel|glass/i.test(h); }, 'Olive Wood Only'],
    [/crystal/i, 'Olive Wood + Crystal'],
    [/hematite/i, 'Olive Wood + Hematite'],
    [/silver tone|pewter cross icon metal beads/i, 'Olive Wood + Silver Tone']
  ]}
]};

/* Rosary Scented — 4 products (HLF/data/rosary-scented.json). Scent + bead material are in the titles. */
R['rosary-scented'] = { groups: [
  { name: 'Scent', src: 'title', rules: [
    [/\brose\b/i, 'Rose'],
    [/jasmin/i, 'Jasmine']
  ]},
  { name: 'Bead Material', src: 'title', one: true, rules: [
    [/petals?/i, 'Real Flower Petals (Jerusalem)'],
    [/scented/i, 'Scented Wood']
  ]}
]};

/* Rosary Stone — 13 products (HLF/data/rosary-stone.json). Bead material + soil center are in the titles. */
R['rosary-stone'] = { groups: [
  { name: 'Bead Material', src: 'title', rules: [
    [/hematite/i, 'Hematite'],
    [/malachite/i, 'Malachite'],
    [/onyx/i, 'Black Onyx'],
    [/red glass|glass beads/i, 'Red Glass'],
    [/amethyst/i, 'Amethyst']
  ]},
  /* chaplets (single decade, no center) get no value; every other non-soil rosary has an ordinary cross/medal center */
  { name: 'Center', src: 'title', skip: /chaplet/i, rules: [
    [/soil/i, 'Jerusalem Soil Center']
  ], fallback: 'Regular Cross Center' }
]};

/* Souvenirs Leather Bags — 19 live products (data/souvenirs-leather-bags.json). Type/size/strap all in titles. */
R['souvenirs-leather-bags'] = { groups: [
  { name: 'Bag Type', src: 'title', one: true, rules: [
    [/laptop|business/i, 'Business/Laptop Bag'],
    [/back bag|backpack/i, 'Backpack'],
    [/messenger|shoulder bag|cross-?body/i, 'Messenger/Shoulder Bag']
  ]},
  /* named size first; unnamed bags bucketed by largest dimension (XSmall 10", Small 12.4", Medium 14", Large 16") */
  { name: 'Size', src: 'title', one: true, rules: [
    [/x-?small/i, 'XSmall'],
    [/\bsmall\b/i, 'Small'],
    [/\bmedium\b|\bmeduim\b/i, 'Medium'],
    [/\blarge/i, 'Large'],
    [inch(0, 10.5), 'XSmall'],
    [inch(10.5, 13), 'Small'],
    [inch(13, 15.5), 'Medium'],
    [inch(15.5, 99), 'Large']
  ]},
  { name: 'Shoulder Strap', src: 'title', skip: /back bag|backpack/i, rules: [
    [/strap can be removed|removable strap/i, 'With Removable Strap']
  ], fallback: 'Without Strap' }
]};

/* Souvenirs Posters — 8 live products (data/souvenirs-posters.json). Location and format in titles. */
R['souvenirs-posters'] = { groups: [
  { name: 'Location / Subject', src: 'title', rules: [
    [/jerusalem view|via dolorosa/i, 'Jerusalem'],
    [/nazareth/i, 'Nazareth'],
    [/bethlehem/i, 'Bethlehem'],
    [/masada|dead sea/i, 'Masada/Dead Sea'],
    [/galilee|zippori|sepph/i, 'Galilee'],
    [/via dolorosa/i, 'Via Dolorosa'],
    [/family tree|genealog|wall chart|bible chart/i, 'Genealogy/Bible Chart']
  ]},
  { name: 'Format', src: 'title', one: true, rules: [
    [/39\s*x\s*14|panorama/i, 'Large Panorama (39x14")'],
    [/laminated/i, 'Laminated Site Poster (16.5x11.8")'],
    [/wall chart/i, 'Wall Chart']
  ]}
]};

/* Souvenirs Wall Hangings — 10 live products (data/souvenirs-wall-hangings.json). Subject in titles + Pattern/Style options. */
R['souvenirs-wall-hangings'] = { groups: [
  { name: 'Subject', rules: [
    [/mother mary/i, 'Blessed Mother Mary'],
    [/sacred hea(r)?t/i, 'Sacred Heart of Jesus'],
    [/messianic|grafted in/i, 'Messianic/Grafted In'],
    [/agony of (our|the) lord/i, 'Agony of Our Lord'],
    [/saint theresa|st\.? theresa/i, 'Saint Theresa'],
    [/mary with child|mother mary and child/i, 'Mary with Child']
  ]},
  { name: 'Size', src: 'title', rules: [
    [inch(0, 13), 'Small (8-10x2")'],
    [inch(13, 99), 'Large/Extra Large (17.5x8")']
  ]},
  { name: 'Color', src: 'opt', opt: /colou?r/i, skip: /^(?!.*banner)/i, rules: [
    [/blue/i, 'Blue'],
    [/maroon/i, 'Maroon (banner variants only)']
  ]}
]};

/* Souvenirs — 81 live products (data/souvenirs.json). Mixed parent collection; type comes from titles. */
R['souvenirs'] = { groups: [
  { name: 'Product Type', hide: ['Decorative Box','Communion Set'], src: 'title', one: true, rules: [
    [/holy water/i, 'Holy Water'],
    [/^(?!.*(kufiy|keffiyeh|shemagh)).*\b(scarf|shawl)\b/i, 'Scarf/Prayer Shawl'],
    [/kufiy|keffiyeh|shemagh/i, 'Kufiyah'],
    [/\bmagnet\b/i, 'Magnet'],
    [/poster|wall chart|via dolorosa/i, 'Poster/Map'],
    [/wall hanging|banner hanger/i, 'Wall Hanging'],
    [/djembe|jembe|\bdrum\b/i, 'Drum'],
    [/dead sea|ein gedi/i, 'Dead Sea Products'],
    [/all metal|altar table crucifix|small crucifix with sticker/i, 'Metal Cross'],
    [/^(?!.*communion).*leather.*\bbag\b/i, 'Leather Bag'],
    [/\bbox\b/i, 'Decorative Box'],
    [/communion/i, 'Communion Set']
  ]},
  { name: 'Style / Tradition', rules: [
    [/crucifix|\bcross\b|mother mary|\bmary\b|saint|\bst\.|sacred hea(r)?t|jesus|our lord|holy family|last supper|holy water|rosary|communion|chalice|nativity|via dolorosa|lord prayer|holy spirit|christian|commandments/i, 'Christian/Catholic'],
    [/messianic|grafted in/i, 'Messianic'],
    [/kufiy|keffiyeh|shemagh|palestin/i, 'Cultural/Palestinian']
  ]}
]};

/* Stones River Rock — 48 live products (data/stones-river-rock.json); same rules as stones (minus glass/gemstone). */
R['stones-river-rock'] = { groups: [
  { name: 'Theme', src: 'title', rules: [
    [/scripture|biblical|\bbible\b|\d+\s*:\s*\d+|i am statements|saved by grace|shema/i, 'Biblical Scripture'],
    [/quote|proverb|steve jobs|picasso|positive|don't judge|angel watching|god sees every tear|wish you were here|with inspirational words|different words|encourag|courage to believe|serenity|amazing grace|\(not to\) worry/i, 'Inspirational Quote'],
    [/love and romance|i love you/i, 'Love and Romance'],
    [/fruits? of the (holy )?spirit/i, 'Fruits of the Holy Spirit']
  ]},
  { name: 'Stone Type', src: 'title', rules: [
    [/^(?!.*(black|glass|gemstone|semi-precious)).*\bstones?\b/i, 'Natural River Rock'],
    [/\bblack\b/i, 'Black Stone']
  ]},
  /* title size wins; titles without one fall back to the description. 1-2" pebbles and the 3-6" set get no size. */
  { name: 'Size', one: true, rules: [
    [function(h, p){
      var t = p.title || '', s;
      if (/extra large|3-6/i.test(t)) return false;
      s = inch(0, 999)(t) ? t : String(p.body_html || '').replace(/<[^>]+>/g, ' ');
      if (/\b1\s*(-|to|\u2013)\s*2\s*inch/i.test(s)) return false;
      /* single "Collection - Stone N" pieces with no size anywhere belong to the standard 2-3" line */
      if (!inch(0, 999)(s) && /collection\s*[-\u2013]\s*stone\b/i.test(t)) return true;
      return inch(1.75, 3.75)(s);
    }, 'Standard (2-3")'],
    [function(h, p){ return /extra large/i.test(p.title || ''); }, 'Extra Large (4-5")']
  ]},
  { name: 'Set Size', src: 'title', one: true, rules: [
    [/collection\s*[-\u2013]\s*stone\b|\bstone\b(?!s)|amazing grace/i, 'Single'],
    [/set of 6\b|\(6 /i, 'Set of 6'],
    [/set of 10\b|\b10 polished/i, 'Set of 10'],
    [/set of 12\b|\b12 stones/i, 'Set of 12']
  ]}
]};

/* Stones — 58 live products (data/stones.json). Theme/type/set in titles; size from title, else description. */
R['stones'] = { groups: [
  { name: 'Theme', src: 'title', rules: [
    [/scripture|biblical|\bbible\b|\d+\s*:\s*\d+|i am statements|saved by grace|shema/i, 'Biblical Scripture'],
    [/quote|proverb|steve jobs|picasso|positive|don't judge|angel watching|god sees every tear|wish you were here|with inspirational words|different words|encourag|courage to believe|serenity|amazing grace|\(not to\) worry/i, 'Inspirational Quote'],
    [/love and romance|i love you/i, 'Love and Romance'],
    [/fruits? of the (holy )?spirit/i, 'Fruits of the Holy Spirit']
  ]},
  { name: 'Stone Type', src: 'title', rules: [
    [/^(?!.*(black|glass|gemstone|semi-precious)).*\bstones?\b/i, 'Natural River Rock'],
    [/\bblack\b/i, 'Black Stone'],
    [/\bglass\b/i, 'Glass Stone'],
    [/gemstone|semi-precious/i, 'Semi-Precious Gemstone']
  ]},
  /* title size wins; titles without one fall back to the description. 1-2" pebbles and the 3-6" set get no size. */
  { name: 'Size', one: true, rules: [
    [function(h, p){
      var t = p.title || '', s;
      if (/extra large|3-6/i.test(t)) return false;
      s = inch(0, 999)(t) ? t : String(p.body_html || '').replace(/<[^>]+>/g, ' ');
      if (/\b1\s*(-|to|\u2013)\s*2\s*inch/i.test(s)) return false;
      /* single "Collection - Stone N" pieces with no size anywhere belong to the standard 2-3" line */
      if (!inch(0, 999)(s) && /collection\s*[-\u2013]\s*stone\b/i.test(t)) return true;
      return inch(1.75, 3.75)(s);
    }, 'Standard (2-3")'],
    [function(h, p){ return /extra large/i.test(p.title || ''); }, 'Extra Large (4-5")']
  ]},
  { name: 'Set Size', src: 'title', one: true, rules: [
    [/collection\s*[-\u2013]\s*stone\b|\bstone\b(?!s)|amazing grace/i, 'Single'],
    [/set of 6\b|\(6 /i, 'Set of 6'],
    [/set of 10\b|\b10 polished/i, 'Set of 10'],
    [/set of 12\b|\b12 stones/i, 'Set of 12']
  ]}
]};

/* Tallits — 37 products (data/tallits.json). Colors in Color options or titles; sizes as "72 x 32" / '24" L x 72" W' / '24/72' (bucketed on the narrow side). */
R['tallits'] = { groups: (function(){
  function dims(s){
    var out = [], m, re = /(\d{2}(?:\.\d+)?)\s*(?:"|''|\u201d)?\s*(?:L\b|long\b|inch(?:es)?\b)?\s*(?:x|\/|and)\s*(\d{2}(?:\.\d+)?)/i;
    while ((m = re.exec(s))) { out.push(Math.min(+m[1], +m[2])); s = s.slice(m.index + m[0].length); }
    return out;
  }
  function sizes(h, p){
    var out = [], d = dims(h), m;
    (p.options || []).forEach(function(o){
      if (!/size/i.test(o.name || '')) return;
      (o.values || []).forEach(function(v){
        if (/\bsmall\b/i.test(v)) out.push('S');
        if (/\bmedium\b/i.test(v)) out.push('M');
        if (/\blarge\b/i.test(v)) out.push('L');
      });
    });
    if (!d.length && !out.length){
      m = String(p.body_html || '').replace(/<[^>]+>/g, ' ').match(/(\d{2})\s*x\s*(\d{2})\s*(?:"|inch|pulgadas)/i);
      if (m) d.push(Math.min(+m[1], +m[2]));
    }
    d.forEach(function(x){ out.push(x < 23 ? 'S' : x < 35 ? 'M' : 'L'); });
    return out;
  }
  function S(k){ return function(h, p){ return sizes(h, p).indexOf(k) !== -1; }; }
  function blue(h){ return /\bblue\b/i.test(h.split(/(?:royal|sky|dark|navy|light)[\s-]*blue/i).join(' ')); }
  var NOT_TALLIT = /\bbag\b|tzitzit/i;
  return [
  { name: 'Style / Tradition', one: true, rules: [
    [/messian|messiah|grafted|new covenant|mesi.?nico/i, 'Messianic']
  ], fallback: 'Jewish/Traditional' },
  { name: 'Size', skip: NOT_TALLIT, rules: [
    [S('S'), 'Small (72x22", 18x72")'],
    [S('M'), 'Medium (72x32", 24x72")'],
    [S('L'), 'Large (72x36", 47x68", 80x60")']
  ]},
  { name: 'Color', src: 'opt', opt: /colou?r/i, skip: NOT_TALLIT, rules: [
    [/black/i, 'Black'],
    [blue, 'Blue'],
    [/navy|dark[\s-]*blue/i, 'Navy'],
    [/purple|lavender/i, 'Purple'],
    [/\bred\b/i, 'Red'],
    [/royal[\s-]*blue/i, 'Royal Blue'],
    [/sky[\s-]*blue|light[\s-]*blue/i, 'Sky Blue'],
    [/gold/i, 'Gold'],
    [/silver/i, 'Silver'],
    [/pink/i, 'Pink'],
    [/green/i, 'Green'],
    [/white/i, 'White']
  ]},
  { name: 'Style / Design', src: 'title', skip: NOT_TALLIT, rules: [
    [/messiah tallit/i, 'Messiah Tallit'],
    [/grafted/i, 'Grafted In'],
    [/new covenant/i, 'New Covenant'],
    [/spanish|esquinas|espa.?olas/i, 'Spanish Corners'],
    [/stripe|talitnia|acrylic tallit|tallis prayer shawl/i, 'Traditional Striped']
  ]}
  ];
})() };

/* ==================================== end of rules ==================================== */
})(typeof window !== 'undefined' ? window : this);
